// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1PqBU","modalCard":"_2Lwp3"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Dialog/modalTheme.scss
// module id = 1574
// module chunks = 1